class StorageService {
  get () {
    return localStorage
  }

  getItem (key) {
    return localStorage.getItem(key)
  }

  setItem (key, value) {
    localStorage.setItem(key, value)
  }

  clear () {
    localStorage.clear()
  }
}

export default new StorageService()
